// extracted by mini-css-extract-plugin
module.exports = {"base":"TrialHeaderLeft_base__1i9iZ","experiment":"TrialHeaderLeft_experiment__1kK88","trial":"TrialHeaderLeft_trial__2XNp5","state":"TrialHeaderLeft_state__3LgMi"};